import { StateSlice } from '@core/helpers/state-slice';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromSelected from '@product-details/store/actions/selected.action';

export type SelectedState = StateSlice<ReplacementOffer>;

export const initialState: SelectedState = {
  data: {} as ReplacementOffer,
  loaded: false,
  loading: false,
  error: null,
};

const selectedReducer = createReducer(
  initialState,
  on(fromSelected.selectOffer, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loaded: true,
    };
  })
);

export function reducer(
  state: SelectedState | undefined,
  action: fromSelected.SelectedActions
) {
  return selectedReducer(state, action);
}
